import * as React from 'react';
import { IconMapCar16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import { TTransportType } from '../../../types/promoOffersSelection/underground';

export const usePathType = (pathType: TTransportType) => {
  return React.useMemo(() => {
    switch (pathType) {
      case 'walk':
        return <IconMapWalk16 color="current_color" />;
      default:
        return <IconMapCar16 color="current_color" />;
    }
  }, [pathType]);
};
